import {FlexRow} from '../../../components/utility/flex_row.tsx';
import {FlexColumn} from '../../../components/utility/flex_column.tsx';
import {Icon} from '../../../components/icon/icon.tsx';
import {Alignment} from '../../../enums/alignment.ts';
import {Widget} from '../../../components/widget/widget.tsx';
import {AltButton} from '../../../components/button/alt_button.tsx';
import {ButtonPosition} from '../../../enums/button_position.ts';
import {useAppDispatch, useAppSelector} from '../../../store/store.ts';
import {__} from '../../../support/lang/translations.ts';
import {useCallback} from 'react';
import {messaging} from '../../../firebase/config.ts';
import {registerDeviceToken} from '../../../store/slices/notifications_slice.ts';
import {onMessage} from 'firebase/messaging';
import {Bounce, toast} from 'react-toastify';
import {redirect} from 'react-router-dom';

export function NotificationPermissionsDisabledWidget() {
    const exchangeToken = useAppSelector((state) => state.exchangeToken);
    const notifications = useAppSelector((state) => state.notifications);
    const dispatch = useAppDispatch();
    const iosMobileDevice = /(iPhone|iPod|iPad)/i.test(navigator.userAgent);

    const askPermission = useCallback(() => {
        if (messaging && exchangeToken.token) {
            if (!notifications.deviceTokenRegistered) {
                dispatch(registerDeviceToken({token: exchangeToken.token}));
            }
            onMessage(messaging, (payload) => {
                toast.info(payload.notification?.title ?? __('notifications.default'), {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    onClick: () => {
                        redirect('/notifications');
                    },
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'light',
                    transition: Bounce,
                });
            });
        }
    }, [messaging, exchangeToken, notifications, onMessage, dispatch]);

    if (!messaging || notifications.deviceTokenRegistered || iosMobileDevice) {
        return null;
    }

    return (
        <Widget isInteractive={true} onClick={askPermission}>
            <FlexRow>
                <FlexColumn>
                    <FlexRow>
                        <Icon iconClassName="fa-light fa-info-circle" outline={false} />
                        <FlexColumn>
                            {notifications.permissionState === 'denied' ? (
                                <strong style={{marginLeft: '1rem'}}>
                                    {__('widgets.notification_permission_disabled.denied')}
                                </strong>
                            ) : (
                                <strong style={{marginLeft: '1rem'}}>
                                    {__('widgets.notification_permission_disabled.title')}
                                </strong>
                            )}
                            <span style={{marginLeft: '1rem'}}>
                                {__('widgets.notification_permission_disabled.content')}
                            </span>
                        </FlexColumn>
                    </FlexRow>
                </FlexColumn>

                <FlexColumn alignment={Alignment.End}>
                    <AltButton position={ButtonPosition.Right}>
                        <i className="fa-light fa-arrow-right" />
                    </AltButton>
                </FlexColumn>
            </FlexRow>
        </Widget>
    );
}
